import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchUser,
  fetchUsers,
  updateUser
} from "../../actions/callrecorder/usersActions";

export interface UserInterface {
  url: string;

  id: number;
  uid: string | null;
  xuid: number | null;
  cnumber: string;
  reg_cid: string | null;

  balance: string;
  verified: boolean;
  suspicious: boolean;
  ads: boolean;
  rec: boolean;

  voice_changer: string;
  bundle_id: number;
  provider_id: number | null;
  bg_noise_id: number | null;

  serverip: string | null;
  pushkit_token: string | null;
  dno_id: number | null;
  user_number_id: number | null;

  bundle: number;
  user_number: number | null;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null,
};

const adaptor = createEntityAdapter<UserInterface>();

const slice = createSlice({
  name: 'users',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchUsers.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.users;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchUser.fulfilled, (state, action) => {
        const user = Object.values(action.payload.user)[0];
        state.entities[user.id] = user;
      })

      // #update
      .addCase(updateUser.fulfilled, (state, action) => {
        const user = Object.values(action.payload.user)[0];
        state.entities[user.id] = user;
      })
      .addCase(updateUser.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setEditError,
} = slice.actions;

export const {
  selectById: selectUserById,
  selectIds: selectUserIds,
  selectEntities: selectUserEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.users);
